<template>
    <div>
        <!-- 搜索框 -->
        <a-card title="权限与菜单管理">
            <a-form layout="inline" @submit="handleModalHide" :form="form">
                <a-form-item label="选择平台">
                    <a-select v-model="searchP.platfromcode" style="width:160px;" placeholder="请选择">
                        <a-select-option v-for="(item) in platformlist" :key="item.platfromcode"
                            v-model="item.platfromcode">
                            {{ item.platfromname + '【' + item.platfromcode + '】' }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选
                    </a-button>
                </a-form-item>
                <a-form-item>
                    <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                    </a-button>
                </a-form-item>
            </a-form>
            <template slot="extra">
                <!--                <a-button style="margin-right: 15px"  type="primary" @click="handleNewMenu">新建权限与菜单</a-button>-->
                <a-tooltip>
                    <template slot="title">
                        <span>id已存在的记录会被覆盖</span>
                    </template>
                    <a-upload name="file" :multiple="false"
                        action="https://032001.zhonglunnet.com" :headers="headers"
                        :data="handleImportFile" @change="handleChange">
                        <a-button type="primary" :loading="isImporting">
                            <a-icon type="upload" />
                            导入
                        </a-button>
                    </a-upload>
                </a-tooltip>
            </template>
            <a-spin :spinning="treeLoading" tip="Loading...">
                <a-tree id="ums_tree" :tree-data="treeData" :show-line="showLine" :show-icon="showIcon" style="width:50%;min-width:500px;margin-top:10px;"
                    :auto-expand-parent="autoExpandParent" @select="onSelect" @check="onCheck" @mouseover="onSelect"
                    :expandedKeys="expandedKeys" @expand="handleExpand">
                    <template slot="custom" slot-scope="item">
                        <span>
                            <a-icon :type="item.icon" /> {{ item.title }}</span>
                        <a-popconfirm title="是否确认导出？" class="but_type" style="right:180px;"
                            @confirm="() =>handleExportService(item)" :loading="isExporting">
                            <a-button type="link" class="but_type" style="right:120px;">导出
                            </a-button>
                        </a-popconfirm>
                        <a-button type="link" class="but_type" style="right:120px;" @click="()=> append(item)">新建下级
                        </a-button>
                        <a-button type="link" class="but_type" style="right:80px;" @click="()=> edit(item)">编辑
                        </a-button>
                        <a-popconfirm @confirm="() => remove(item)">
                            <template slot="title">
                                <p>{{ '确认将【' + item.name + '】删除？' }}</p>
                            </template>
                            <a-button type="link" class="but_type">删除</a-button>
                        </a-popconfirm>

                        <div class="underline"></div>
                    </template>

                </a-tree>
            </a-spin>
            <menuItem ref="addeditmenu" @onModalHide="handleModalHide">
            </menuItem>
        </a-card>
    </div>
</template>
<script>
import menuItem from './item'


export default {
    data() {
        return {
            expandedKeys: [],
            form: this.$form.createForm(this),
            showLine: true,
            showIcon: false,
            exportId: '',
            importId: '',
            isExporting: false,
            isImporting: false,
            treeData: [],
            autoExpandParent: false,
            treeLoading:false,
            searchP: {
                platfromcode: 'fp',
            },
            headers: {
                authorization: 'authorization-text',
            },
            platformlist: [],
        };
    },
    methods: {
        handleExpand(expandedKeys){
            this.expandedKeys = expandedKeys
        },
        getSearchPlatFromConfig() {
            let c_params = {
                urlparams: false,
            }
            this.tLoading = true;
            this.$store.dispatch({
                type: "ums/selectPlatFromConfig",
                params: c_params
            }).then((res) => {
                console.log(res);
                this.platformlist = res.data.data.filter(item => { return item.platfromcode != 'YXL' });
            })
        },
        handleNewMenu() {
            if (this.searchP.platfromcode == '') {
                this.message.error("请选择平台")
                return false
            }
            let empty_menu = {
                title: '新建一级菜单',
                pid: '0',
                pmenucode:'1',
                menucode:'1000',
                url: '',
                level: '1',
                name: '',
                ordernum: '',
                platfromcode: this.searchP.platfromcode,
                id: '',
                icon: ''
            }
            this.$refs.addeditmenu.onModalInit(empty_menu);
        },
        handleModalHide() {
            this.getAllMenu()
        },
        onSelect(keys, event) {
            console.log('Trigger Select', keys, event);
        },
        onCheck() {
        },

        handleSearchReset() {
            this.searchP.platfromcode = '';
            this.handleModalHide();
        },
        //新建下级
        append(item) {
            console.log(item)
            let empty_menu = {
                title: '新建【' + item.name + '】的下级',
                pid: item.id,
                pmenucode:item.menucode,
                url: '',
                level: parseInt(item.level) + 1,
                platfromcode: item.platfromcode,
                name: '',
                ordernum: '',
                id: '',
                icon: ''
            }
            this.$refs.addeditmenu.onModalInit(empty_menu);
        },
        edit(item) {
            item.title = '编辑【' + item.name + '】'
            this.$refs.addeditmenu.onModalInit(item);
        },
        remove(item) {
            console.log(item)
            this.$store.dispatch({
                type: "ums/deleteMenuConfig",
                params: {id: item.id}
            }).then((res) => {
                if (res.status == '200') {
                    this.getAllMenu()
                }
            });
        },
        //递归树结构
        handleTreeData(treeItem) {
            treeItem.title = treeItem.name;
            treeItem.key = treeItem.id;
            treeItem.children = [];
            treeItem.scopedSlots = {title: 'custom'};
            treeItem.submenuList.sort(function (a, b) {
                return parseInt(a.ordernum) > parseInt(b.ordernum) ? 1 : -1
            });

            for (let index = 0; index < treeItem.submenuList.length; index++) {
                const r_child = treeItem.submenuList[index];
                r_child.slots = {
                    icon: r_child.icon,
                }
                treeItem.children.push(this.handleTreeData(r_child))

            }
            return treeItem;
        },

        handleExportService(item) {
            this.isExporting = true
            this.$store
                .dispatch({
                    type: 'servicekey/exportService',
                    params: {
                        exportbusinesstype: 'exportUniteMenu',
                        exportparamsdesc: '{}',
                        id: item.id,
                    }
                })
                .then((res) => {
                    if (res.data.success == '1') {
                        console.log(res)
                        this.exportId = res.data.data
                        this.checkExportStatue();

                    } else {
                        this.isExporting = false;
                        this.message.error('导出失败')
                    }
                }).catch((e) => {
                    this.isExporting = false;
                    this.message.error("" + e.message)
                });
        }, checkExportStatue() {
            if (this.checkStatuesTime > 3) {
                this.message.error('超出请求次数')
                this.checkStatuesTime = 0;
                clearTimeout(this.timer)
                this.isExporting = false
                return;
            }
            let that = this;
            this.timer = setTimeout(function () {
                that.$store
                    .dispatch({
                        type: 'servicekey/checkExportStatue',
                        params: {id: that.exportId}
                    })
                    .then((res) => {
                        if (res.data.success == 1) {
                            if (res.data.data.exportstatus == 1) {
                                //导出成功
                                that.isExporting = false
                                let temp_File_Str = res.data.data.exportfilefull;
                                let files = temp_File_Str.split(',')
                                for (let index = 0; index < files.length; index++) {
                                    const element = files[index];
                                    window.open(element)
                                }

                            } else {
                                that.checkExportStatue()
                            }
                        } else {
                            that.checkExportStatue()
                        }
                        console.log(res)
                        that.checkStatuesTime++
                    });
            }, 2000);

        },
        handleImportFile(file) {
            // let that = this;
            let result = this.D.syncSelect({
                type: 'servicekey/importConfig',
                params: {}
            })
            if (result.success !== '1') {
                // that.message.error(result['errorMsg']);
                return false;
            }
            const data = result.data;
            const {
                dir,
                policy,
                accessid,
                callback,
                signature
            } = data;
            const token = {
                policy: policy,
                OSSAccessKeyId: accessid,
                success_action_status: '200',
                callback: callback,
                signature: signature
            };
            const objName = dir + this.getUniqueCode() + this.getSuffix(file.name);
            file.objName = objName;
            return {
                ...token,
                key: objName
            }

        },
        getUniqueCode() {
            const s = [];
            const hexDigits = "0123456789abcdef";
            for (let i = 0; i < 36; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
            }
            s[14] = "4";
            s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
            s[8] = s[13] = s[18] = s[23] = "-";
            return s.join("");
        },
        getSuffix(filename) {
            const pos = filename.lastIndexOf('.');
            let suffix = '';
            if (pos !== -1) {
                suffix = filename.substring(pos)
            }
            return suffix;
        },
        //上传文件结果处理
        handleChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                this.saveImportRecord(info.file.objName, info.file.originFileObj.name);
                this.message.success(`${info.file.name} file uploaded successfully`);

            } else if (info.file.status === 'error') {
                this.message.error(`${info.file.name} file upload failed.`);
            }
        },
        saveImportRecord(fileUrl, filename) {
            this.isImporting = true;
            this.$store
                .dispatch({
                    type: 'servicekey/saveImportService',
                    params: {
                        importbusinesstype: 'importUniteMenu',
                        shopcode: '125806668',
                        loginuserbranchcode: '1001',
                        sourcefile: fileUrl,
                        filename: filename,
                        syncstatus: 1,
                        updownstatus: 1,
                    }
                })
                .then((res) => {
                    if (res.data.success == '1') {
                        console.log(res)
                        this.importId = res.data.data
                        this.checkImportStatue();

                        //刷新页面
                        this.$router.push({
                            path: this.action,
                            query: ''
                        });

                    } else {
                        this.isImporting = false;
                        this.message.error('导入失败')
                    }

                }).catch((e) => {
                    this.isImporting = false;
                    this.message.error('导入失败' + e.message)
                });
        },
        checkImportStatue() {
            if (this.checkStatuesTime > 3) {
                this.message.error('超出请求次数')
                this.checkStatuesTime = 0;
                clearTimeout(this.timer)
                this.isImporting = false
                return;
            }
            let that = this;
            this.timer = setTimeout(function () {
                that.$store
                    .dispatch({
                        type: 'servicekey/checkImportStatue',
                        params: {id: that.importId}
                    })
                    .then((res) => {
                        if (res.data.success == 1) {
                            if (res.data.data.importstatus == 1) {
                                //导入成功
                                that.isImporting = false
                                console.log(res)

                            } else if (res.data.data.importstatus == 2) {
                                that.isImporting = false
                                that.message.error(res.data.data.errormsg)
                            } else {
                                that.checkImportStatue()
                            }
                        } else {
                            that.checkImportStatue()
                        }
                        console.log(res)
                        that.checkStatuesTime++
                    });
            }, 2000);

        },
        getAllMenu() {
            // if (this.searchP.platfromcode == '') {
            //     this.message.error("请选择平台")
            //     return false
            // }
            this.treeLoading = true;
            let c_params = {
                ...this.searchP,
                urlparams: false,
            }
            this.$store.dispatch({
                type: "ums/searchMenuConfigTree",
                params: c_params,
                showMsg: false
            },).then((res) => {
                let origin_data = res.data.data
                //排序
                origin_data.sort(function (a, b) {
                    return parseInt(a.ordernum) > parseInt(b.ordernum) ? 1 : -1
                });
                for (let index = 0; index < origin_data.length; index++) {
                    const element = origin_data[index];
                    element.title = element.name;
                    element.key = element.id;
                    element.scopedSlots = {title: 'custom'};
                    this.expandedKeys.push(element.id);
                    this.handleTreeData(element)
                }

                this.treeData = origin_data
                this.treeLoading = false;

            });
        },
    },
    computed: {},
    components: {
        menuItem
    },
    mounted() {
        this.getAllMenu()
        this.getSearchPlatFromConfig()
    }
};
</script>
<style scoped>
.ant-card-body .but_type {
    float: right;
    position: absolute;
    right: 40px;
}

.underline {
    position: absolute;
    width: calc(100% - 75px);
    height: 5px;
    border-bottom: 1px solid #f4e4e4;
}

#ums_tree{
    min-height: 800px;
}

</style>


<style>

#ums_tree .ant-tree-treenode-selected .underline {
    border-bottom: 2px solid gray;
}
</style>
